import { AbstractControl, ValidationErrors } from '@angular/forms';

export abstract class NoHashValidator {
  private static readonly REGEX = /#/;

  static noHashes(control: AbstractControl): ValidationErrors {
    if (!control || !control.value) {
      return null;
    }

    const regExp = new RegExp(NoHashValidator.REGEX);

    return regExp.test(control.value) ? { noHashes: { valid: false } } : null;
  }
}
